import { render, staticRenderFns } from "./CancellationRequests.vue?vue&type=template&id=9f951852&scoped=true&"
import script from "./CancellationRequests.vue?vue&type=script&lang=js&"
export * from "./CancellationRequests.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRequests.vue?vue&type=style&index=0&id=9f951852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f951852",
  null
  
)

export default component.exports